export const homeHeader = {
  marketingLink: 'Conocé más',
}
